// extracted by mini-css-extract-plugin
export var label = "_h4-2";
export var slideContainer = "_h4-0";
export var slider = "_h4-1";